<template>
    <div class="notification-toast">
        <div class="notification-toast__title">
            {{ notification.title }}
        </div>
        <div
            class="notification-toast__body"
            v-html="notification.body"
        />
        <div class="notification-toast__footer">
            <button
                class="btn btn-sm btn-primary"
                v-if="notification.action_text"
                @click="doAction(notification)"
            >
                {{ notification.action_text }}
            </button>
            <button
                class="btn btn-sm btn-link"
                @click="dismiss(notification)"
            >
                Dismiss
            </button>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    props: {
        notification: {
            type: Object,
            required: true,
        },
    },
    methods: {
        ...mapActions('notifications', [
            'dismiss',
            'doAction',
        ]),
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/NotificationToastComponent.vue